import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, hasOAuthCallback } from './AuthProvider';
import { homeForProfile } from '../lib/refonteNav';

interface ProtectedRouteProps {
  children: React.ReactNode;
  /** Rôles autorisés. Si fourni et que le rôle n'y est pas → redirige vers son accueil. */
  allow?: string[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allow }) => {
  const { isAuthenticated, isLoading, profile } = useAuth();
  const location = useLocation();

  // Tant que la session n'est pas résolue (mount + retour OAuth), NE PAS rediriger : sinon on
  // quitte la page et on efface le token OAuth de l'URL avant que Supabase l'ait lu → boucle.
  if (isLoading || hasOAuthCallback()) {
    return (
      <div className="refonte-scope min-h-screen grid place-items-center bg-cream">
        <div className="flex items-center gap-2 text-dim font-mono text-[13px]">
          <span className="w-4 h-4 rounded-full border-2 border-hook-rose border-t-transparent animate-spin" /> Connexion…
        </div>
      </div>
    );
  }

  // Non authentifié → login (en gardant la destination voulue)
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Authentifié mais rôle non autorisé sur cette route → renvoyé vers son accueil
  if (allow && profile && !allow.includes(profile.role)) {
    return <Navigate to={homeForProfile(profile)} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
